// extracted by mini-css-extract-plugin
export default {"word":"style_word__dp-q9","active":"style_active__HOkhg","word-divider":"style_word-divider__b0pxn","synonym":"style_synonym__Bzugq","grapheme":"style_grapheme__aV+8t"};